module.exports = __webpack_public_path__ + "img/startsida.ca19937c.jpg";